import { LocalizedText } from '@mews/framework';
import { Button } from '@optimus-web/core';

export default (props: $TSFixMe) => {
    const { title, icon, primary, ...other } = props;

    return (
        <Button icon={icon} data-test-icon-button={icon} {...other} type="submit">
            {typeof title === 'string' ? <LocalizedText textKey={title as Mews.TextKey} /> : title}
        </Button>
    );
};
